import iconStar from "../../../../assets/images/landing/icon-star.svg";
import iconClockBolt from "../../../../assets/images/landing/icon-clock-bolt.svg";
import iconNetwork from "../../../../assets/images/landing/icon-network.svg";

import badgeSmartRewards from "../../../../assets/images/landing/badge-smart-rewards.svg";
import badgeIntelligentProcurement from "../../../../assets/images/landing/badge-intelligent-procurement.svg";
import badgeInstantQuotations from "../../../../assets/images/landing/badge-instant-quotations.svg";
import badgeFlexiblePayments from "../../../../assets/images/landing/badge-flexible-payments.svg";

import why1Wave1 from "../../../../assets/images/landing/why1-wave-1.svg";
import why1Wave2 from "../../../../assets/images/landing/why1-wave-2.svg";
import why1Wave3 from "../../../../assets/images/landing/why1-wave-3.svg";
import why1Wave4 from "../../../../assets/images/landing/why1-wave-4.svg";
import why1Wave5 from "../../../../assets/images/landing/why1-wave-5.svg";
import why3Bg from "../../../../assets/images/landing/why3-bg.jpg";
import why4Bg from "../../../../assets/images/landing/why4-bg.jpg";

import stepsWave1 from "../../../../assets/images/landing/steps-wave-1.svg";
import stepsWave2 from "../../../../assets/images/landing/steps-wave-2.svg";
import stepsWave3 from "../../../../assets/images/landing/steps-wave-3.svg";
import stepsWave4 from "../../../../assets/images/landing/steps-wave-4.svg";
import stepsWave5 from "../../../../assets/images/landing/steps-wave-5.svg";

import ctaWave1 from "../../../../assets/images/landing/cta-wave-1.svg";
import ctaWave2 from "../../../../assets/images/landing/cta-wave-2.svg";
import ctaWave3 from "../../../../assets/images/landing/cta-wave-3.svg";
import ctaWave4 from "../../../../assets/images/landing/cta-wave-4.svg";
import ctaWave5 from "../../../../assets/images/landing/cta-wave-5.svg";

import catLaptops from "../../../../assets/images/landing/cat-laptops.png";
import catDesktops from "../../../../assets/images/landing/cat-desktops.png";
import catPrinters from "../../../../assets/images/landing/cat-printers.png";
import catSmartphones from "../../../../assets/images/landing/cat-smartphones.png";

export const featureIcons = {
  rewards: iconStar,
  quotation: iconClockBolt,
  intelligence: iconNetwork,
};

export const whyBadges = {
  smartRewards: badgeSmartRewards,
  intelligentProcurement: badgeIntelligentProcurement,
  instantQuotations: badgeInstantQuotations,
  flexiblePayments: badgeFlexiblePayments,
};

export const smartRewardsWaves = [why1Wave1, why1Wave2, why1Wave3, why1Wave4, why1Wave5];

export const whyBackgrounds = {
  instantQuotations: why3Bg,
  flexiblePayments: why4Bg,
};

export const stepsWaves = [stepsWave1, stepsWave2, stepsWave3, stepsWave4, stepsWave5];
export const ctaWaves = [ctaWave1, ctaWave2, ctaWave3, ctaWave4, ctaWave5];

export const categoryImages = {
  laptops: catLaptops,
  desktops: catDesktops,
  printers: catPrinters,
  smartphones: catSmartphones,
};
